import { mutator } from "satcheljs";

import { clearFilters } from "../..";
import { ClearFiltersActionMessage } from "../../actions/filter/ClearFiltersActionMessage";
import schedulesViewStateStore from "../../store/store";

/**
 * Clears the schedule view filters.
 */
export const clearFiltersMutator = mutator<ClearFiltersActionMessage, void>(clearFilters, ({ shouldClearLabel, viewState }) => {
    const store = viewState ? viewState : schedulesViewStateStore();
    store.filteredMembers.clear();
    store.filteredTags.clear();
    store.selectedShiftFilters.clear();
    store.showFilterError = false;

    if (shouldClearLabel) {
        store.filterHeaderLabel = "";
    }
});
